import Vue from "vue";
import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import TimesheetVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import TimesheetRegisterApi from './api/TimesheetRegisterApi';
import WorkerApi from './api/WorkerApi';
import FarmerRegistryModule, { MODULE_ID as FARM_MODULE_ID } from '@abaco/farm-registry/src/modules/farm-registry';
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module/index";
import PrintApi from './api/PrintApi';
import ActivityApi from './api/ActivityApi';
import GlobalStateModule, { MODULE_ID as GLOBAL_MODULE_ID } from '@abaco/portal-global-state/src/modules/global-state';
import ActivitiesModule, { MODULE_ID as ACTIVITIES_MODULE_ID }  from "@abaco/activities-module/src/modules/activities-module";

export const MODULE_ID = "timesheet_module";

export default class TimesheetModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private brgApiRoot = "/treatment-register-api/api";
    private timeSheetApiRoot = "/timesheet-register-api/api";
    private sitiagriRoot = "/sitiagri-rest-api/api_basic";

    private tsApi!: TimesheetRegisterApi;
    private apiCreated = false;

    private router!: VueRouter;
    private http!: HTTPClient;
    private wkrApi!: WorkerApi;
    private actApi!: ActivityApi;
    private prtApi!: PrintApi;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new TimesheetVuexModule();
    menu: MenuItem[] = [];


    dependsOn = {
        [ACTIVITIES_MODULE_ID]: () => new ActivitiesModule(),
        [FARM_MODULE_ID]: () => new FarmerRegistryModule(),
        [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
    };

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
        Vue.filter("only4Digits", (val: number, additionalText: string) => { return `${Number(val).toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})} ${additionalText}`});
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;

        const TimesheetRegisterModel = (await import("./api/TimesheetRegisterApi")).default;
        this.tsApi = new TimesheetRegisterModel(http, this.brgApiRoot, this.timeSheetApiRoot);

        const WorkerApi = (await import("./api/WorkerApi")).default;
        this.wkrApi = new WorkerApi(http, this.sitiagriRoot);

        const PrintApi = (await import("./api/PrintApi")).default;
        this.prtApi = new PrintApi(http, this.brgApiRoot);

        const ActivityApi = (await import("./api/ActivityApi")).default;
        this.actApi = new ActivityApi(http, this.sitiagriRoot);

    }

    public async updateCompentences(pkCuaa: number) {
        const [canView, canEdit, canValidate ] = await Promise.all([
            this.timesheetApi.canDoAction(pkCuaa, "VIEW"),
            this.timesheetApi.canDoAction(pkCuaa, "EDIT"),
            this.timesheetApi.canDoAction(pkCuaa, "VALIDATE"),

        ])
        this.vuexModule.canView = canView;
        this.vuexModule.canEdit = canEdit;
        this.vuexModule.canValidate = canValidate;
    }


    public get timesheetApi(){
        return this.tsApi;
    }

    get workerApi() {
        return this.wkrApi;
    }

    public get printApi() {
        return this.prtApi;
    }

    public get activityApi() {
        return this.actApi;
    }

}
